import React, { useState } from 'react'

const Context = React.createContext()

const LangContext = ({ children }) => {
  const [lang, setLang] = useState(false)

  return <Context.Provider value={{ lang, setLang }}>{children}</Context.Provider>
}

export { Context, LangContext }